import React from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import PerformanceReview from "./review";

export default function Performance() {
  // Business unit is the real scoping concept here (not the legal/financial
  // `organisation`, which is a different, unrelated entity/collection).
  const { businessUnit } = useSelector((state) => state.Auth);

  // Wait for businessUnit to be set
  if (!businessUnit) {
    return (
      <div className="p-8 text-center text-gray-500">
        <div className="animate-spin w-8 h-8 border-2 border-gray-300 border-t-blue-500 rounded-full mx-auto mb-4" />
        Loading business unit...
      </div>
    );
  }

  // Show "Coming Soon" for "All Business Units"
  if (businessUnit?._id === "ALL") {
    return (
      <div className="flex flex-col items-center justify-center py-32 text-gray-400">
        <div className="text-6xl mb-4">🚀</div>
        <h2 className="text-2xl font-semibold text-gray-600 mb-2">Coming Soon</h2>
        <p className="text-gray-500">Select a specific business unit to view performance</p>
      </div>
    );
  }

  // Show performance based on selected business unit
  return (
    <div className="h-full flex flex-col">
      {/* Content */}
      <div className="flex-1 overflow-auto">
        <Routes>
          <Route path="/*" element={<PerformanceReview businessUnit={businessUnit} />} />
        </Routes>
      </div>
    </div>
  );
}
